import React from "react";
const UploadContext = React.createContext(null);
export const UploadProvider = UploadContext.Provider;
export default UploadContext;